import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { configs } from '../../../constants/configs/configs';
import { Tab, TabData } from './Tab';
import { SideNav } from 'app-components';
import { BREAK_POINTS } from '../../../constants/common/breakpoints';

const StyledSidebarContainer = styled.div<React.ComponentPropsWithRef<'div'>>`
    width: 25%;
    border-radius: 6px;
    .gi-sidebar_nav_list {
        background: ${({ theme }) => theme.defaultWhite};
        font-weight: 400;
    }
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
    }
`;

const StyledHeader = styled.h4`
    background-color: ${({ theme }) => theme.gray9};
    font-size: 16px;
    color: ${({ theme }) => theme.gray2};
    font-weight: 600;
    margin: 0;
    border-left: none;
    border-right: none;
    padding: 16px;
    border-radius: 6px;
    .heading {
        margin-bottom: 0;
        font-size: 16px;
    }
`;

const Sidebar = () => {
    const {
        routes: {
            RIDP,
            RIDP_CONTACT_INFO,
            RIDP_UPLOAD_DOCUMENT,
            RIDP_VERIFICATION_COMPLETE,
            RIDP_CALL_EXPERIAN,
            RIDP_IDENTITY_QUESTION,
            RIDP_TECHNICAL_ERROR,
            RIDP_UPLOAD_DOCUMENT_PROCESS,
        },
    } = configs;

    const location = useLocation();

    const tabData: TabData[] = [
        { id: '1', path: RIDP, messageId: 'ridp.sidebar.getStarted' },
        {
            id: '2',
            path: RIDP_CONTACT_INFO,
            messageId: 'ridp.sidebar.contactInformation',
        },
        {
            id: '3',
            path: RIDP_IDENTITY_QUESTION,
            messageId: 'ridp.sidebar.identityQuestions',
        },
        {
            id: '4',
            path: RIDP_CALL_EXPERIAN,
            messageId: 'ridp.sidebar.callExperian',
        },
        {
            id: '5',
            path: RIDP_UPLOAD_DOCUMENT,
            messageId: 'ridp.sidebar.manualVerification',
        },
        {
            id: '6',
            path: RIDP_UPLOAD_DOCUMENT_PROCESS,
            messageId: 'ridp.sidebar.manualVerification',
        },
        {
            id: '7',
            path: RIDP_VERIFICATION_COMPLETE,
            messageId: 'ridp.sidebar.finish',
        },
        {
            id: '8',
            path: RIDP_TECHNICAL_ERROR,
            messageId: 'ridp.sidebar.finish',
        },
    ];

    const conditionalPaths = [
        RIDP_CALL_EXPERIAN,
        location.pathname === RIDP_TECHNICAL_ERROR ? RIDP_VERIFICATION_COMPLETE : RIDP_TECHNICAL_ERROR,
        location.pathname !== RIDP_UPLOAD_DOCUMENT_PROCESS ? RIDP_UPLOAD_DOCUMENT_PROCESS : null,
        location.pathname !== RIDP_UPLOAD_DOCUMENT ? RIDP_UPLOAD_DOCUMENT : null,
    ];

    const filteredTabData = tabData.filter(tab => {
        // Include tabs with conditional paths if they match the current route
        if (conditionalPaths.includes(tab.path) && location.pathname === tab.path) {
            return true;
        }

        // Include tabs that are not in the conditional paths
        return !conditionalPaths.includes(tab.path);
    });

    return (
        <StyledSidebarContainer className='ridp-side-nav'>
            <StyledHeader>
                <SideNav.Header labelId="ridp.sidebar.header" />
            </StyledHeader>
            <SideNav.Item>
                {filteredTabData.map((tab, _index) => (
                    <Tab key={tab.id} active={location.pathname === tab.path}>
                        <FormattedMessage id={tab.messageId} />
                    </Tab>
                ))}
            </SideNav.Item>
        </StyledSidebarContainer>
    );
};

export default Sidebar;
